import React, { useEffect, useRef } from 'react';
import { FileTextIcon, ClipboardListIcon, FileCheckIcon, PackageIcon, DownloadIcon } from 'lucide-react';
export const ResourcesSection = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const resources = [{
    icon: <FileTextIcon className="h-10 w-10 text-teal" data-id="element-4174" />,
    title: 'Free Checklists',
    description: 'Essential compliance checklists to keep your business on track',
    badge: 'Free',
    badgeColor: 'bg-aqua/80 backdrop-blur-sm text-white'
  }, {
    icon: <ClipboardListIcon className="h-10 w-10 text-teal" data-id="element-4175" />,
    title: 'Compliance Trackers',
    description: 'Track your compliance progress with our easy-to-use tools',
    badge: 'Popular',
    badgeColor: 'bg-gray-200/80 backdrop-blur-sm text-gray-700'
  }, {
    icon: <FileCheckIcon className="h-10 w-10 text-teal" data-id="element-4176" />,
    title: 'Audit Templates',
    description: 'Streamline your audit process with our professional templates',
    badge: 'Essential',
    badgeColor: 'bg-gray-200/80 backdrop-blur-sm text-gray-700'
  }, {
    icon: <PackageIcon className="h-10 w-10 text-white" data-id="element-4177" />,
    title: 'Premium Bundles',
    description: 'Comprehensive toolkits for advanced compliance management',
    badge: 'Premium',
    badgeColor: 'bg-white/20 backdrop-blur-sm text-white',
    featured: true
  }];
  return <section ref={sectionRef} className="py-24 bg-white opacity-0 transition-opacity duration-1000" data-id="element-4178">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4179">
        <div className="max-w-4xl mx-auto mb-16 text-center" data-id="element-4180">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-charcoal tracking-tight" data-id="element-4181">
            Audit-Ready Tools. <br data-id="element-4182" />
            Manager-Ready Resources.
          </h2>
          <p className="text-xl text-gray-600" data-id="element-4183">
            Practical templates and toolkits that save time and simplify
            compliance
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-4184">
          {resources.map((resource, index) => <div key={index} className={`${resource.featured ? 'bg-gradient-to-br from-teal to-teal/90' : 'bg-white border border-gray-200'} rounded-xl p-8 shadow-lg transition-all duration-500 transform hover:-translate-y-2 hover:shadow-xl h-full flex flex-col`} data-id="element-4185">
              <div className="flex justify-between items-start mb-6" data-id="element-4186">
                <div className={`w-16 h-16 rounded-full ${resource.featured ? 'bg-white/20' : 'bg-gray-50'} flex items-center justify-center`} data-id="element-4187">
                  {resource.icon}
                </div>
                <span className={`px-4 py-1.5 text-sm font-medium ${resource.badgeColor} rounded-full`} data-id="element-4188">
                  {resource.badge}
                </span>
              </div>
              <h3 className={`text-2xl font-bold mb-3 ${resource.featured ? 'text-white' : 'text-charcoal'}`} data-id="element-4189">
                {resource.title}
              </h3>
              <p className={`mb-6 ${resource.featured ? 'text-white/90' : 'text-gray-600'} text-lg flex-grow`} data-id="element-4190">
                {resource.description}
              </p>
              <a href="/resources" className={`font-medium inline-flex items-center ${resource.featured ? 'text-white hover:text-aqua' : 'text-teal hover:text-aqua'} transition-colors mt-auto`} data-id="element-4191">
                Learn more
                <svg className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-4192">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-4193"></path>
                </svg>
              </a>
            </div>)}
        </div>
        <div className="text-center mt-16" data-id="element-4194">
          <a href="/resources" className="px-8 py-4 bg-teal text-white font-medium rounded-md hover:bg-gradient-to-r hover:from-teal hover:to-aqua transition-all duration-300 inline-flex items-center shadow-lg transform hover:-translate-y-1" data-id="element-4195">
            <DownloadIcon className="mr-2 h-5 w-5" data-id="element-4196" />
            Get Resources
          </a>
        </div>
      </div>
    </section>;
};